<template>
    <div
        v-if="lastActiveTime"
        class="d-flex flex-row align-items-center gap-2"
    >
        <DateComp
            :value="lastActiveTime.ClockTime"
            format="TIME"
        />
        <span class="badge bg-info bg-opacity-50">{{ lastActiveTime.Bib }}</span>
    </div>
</template>
<script lang="ts" setup>
import { DateComp } from '@/components';
import { RaceContestantTime, type StationRole } from '@/objects/generated';
import { useRaceContestantTimesSubscription } from '@/stores';
import { ref } from 'vue';

const props = defineProps<{
    /**
     * The station role ID to show the last activity for
     */
    value: number;

    /**
     * The station role to show the last activity for
     */
    row: StationRole;
}>();

const lastActiveTime = ref<RaceContestantTime | null>(null);

useRaceContestantTimesSubscription(
    (times) => {
        // We iterate from the back to find the first with the correct stationroleid
        for (let i = times.length - 1; i >= 0; i--) {
            const time = times[i];
            if (time.StationRoleID === props.value) {
                lastActiveTime.value = time;
                break;
            }
        }
    },
    {
        triggerForExistingTimes: true,
        timeTypes: ['Time'],
    },
);
</script>
